import { render, staticRenderFns } from "./FormDateinput.vue?vue&type=template&id=6f06df34&scoped=true&"
import script from "./FormDateinput.vue?vue&type=script&lang=js&"
export * from "./FormDateinput.vue?vue&type=script&lang=js&"
import style0 from "./FormDateinput.vue?vue&type=style&index=0&id=6f06df34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06df34",
  null
  
)

export default component.exports